import React from 'react';
import { SproutIcon } from 'lucide-react';
interface BrainWorldProps {
  text: string;
}
export function BrainWorld({
  text
}: BrainWorldProps) {
  return <aside className="rounded-2xl border border-line bg-paper p-5 hc-strong" aria-label="Brain and world comparison" data-id="element-498" data-mp="3iizlrh0pcnhe">
      <p className="flex items-center gap-2 font-display text-lg font-semibold text-forest" data-id="element-499" data-mp="3rlsd1k9vwz78">
        <SproutIcon size={20} className="text-teal" aria-hidden="true" data-id="element-500" data-mp="a5ag642otba4" />
        Brain + world
      </p>
      <p className="mt-2 text-ink" data-id="element-501" data-mp="5667rfnl7hku">{text}</p>
      <p className="mt-2 text-sm text-ink/80" data-id="element-502" data-mp="55eb01i97dsz">A learning comparison, not an exact biology fact.</p>
    </aside>;
}